import type { RatingScale } from "@sagot/constants";
import type { ConversationItem } from "./inbox-model";

/** The visitor's rating of a conversation in one shape. */
export interface ConversationRating {
  /** 1 to 5; a thumbs-up is stored as 5 and a thumbs-down as 1. */
  value: number;
  scale: RatingScale;
  comment: string | null;
}

/** The rating of a conversation row (`rating`, `rating_scale`, `rating_comment`), or `null` while it is not rated. */
export function ratingOf(conversation: Pick<ConversationItem, "rating" | "rating_scale" | "rating_comment">): ConversationRating | null {
  const { rating } = conversation;
  if (rating === null || rating === undefined) return null;
  return { value: rating, scale: conversation.rating_scale ?? "stars", comment: conversation.rating_comment ?? null };
}
